import {Alert, Attributes} from 'platform/components';
import {Box, Show, VStack} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {useGetMyMultiFactorAuthenticationSettingsQuery} from '@dms/api/base';
import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

export function DeactivatedInfo() {
  const {data: userMfaSettings} = useGetMyMultiFactorAuthenticationSettingsQuery();

  const formatDateTime = useDateTimeFormatter();

  return (
    <Box maxWidth={200}>
      <VStack spacing={5}>
        <Alert variant="error" title={i18n.t('page.myProfile.labels.multiFactorAuthDeactivated')} />

        <Show when={userMfaSettings}>
          {(userMfaSettings) => (
            <VStack spacing={4}>
              <Attributes
                size="third"
                rows={[
                  {
                    label: i18n.t('page.myProfile.labels.multiFactorAuthDeactivatedAt'),
                    value: userMfaSettings.deactivatedAt
                      ? formatDateTime('dateTimeShort', parseDate(userMfaSettings.deactivatedAt))
                      : null,
                  },
                  {
                    label: i18n.t('page.myProfile.labels.multiFactorAuthSetUpAt'),
                    value: formatDateTime('dateTimeShort', parseDate(userMfaSettings.setUpAt)),
                  },
                ]}
              />
            </VStack>
          )}
        </Show>
      </VStack>
    </Box>
  );
}
